/* tslint:disable */
/* eslint-disable */
/* @relayHash dbac65ecbd9a360f20bba2ce7e759d6f */

import { ConcreteRequest } from "relay-runtime";
export type DelegateSlideIn_delegate_QueryVariables = {
    uuid: string;
};
export type DelegateSlideIn_delegate_QueryResponse = {
    readonly delegate: {
        readonly uuid: string;
        readonly firstName: string;
        readonly lastName: string;
        readonly jobTitle: string;
        readonly email: string | null;
        readonly telephone: string | null;
        readonly TTC_ID: string;
        readonly profileImageUrl: string | null;
    } | null;
};
export type DelegateSlideIn_delegate_Query = {
    readonly response: DelegateSlideIn_delegate_QueryResponse;
    readonly variables: DelegateSlideIn_delegate_QueryVariables;
};



/*
query DelegateSlideIn_delegate_Query(
  $uuid: UUID!
) {
  delegate(uuid: $uuid) {
    uuid
    firstName
    lastName
    jobTitle
    email
    telephone
    TTC_ID
    profileImageUrl
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "delegate",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "uuid",
                    "variableName": "uuid"
                }
            ],
            "concreteType": "Delegate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "uuid",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "jobTitle",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "telephone",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "TTC_ID",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "profileImageUrl",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "DelegateSlideIn_delegate_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "DelegateSlideIn_delegate_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "DelegateSlideIn_delegate_Query",
            "id": null,
            "text": "query DelegateSlideIn_delegate_Query(\n  $uuid: UUID!\n) {\n  delegate(uuid: $uuid) {\n    uuid\n    firstName\n    lastName\n    jobTitle\n    email\n    telephone\n    TTC_ID\n    profileImageUrl\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'ce2f692ba23e13e9d3e8863ba41e166e';
export default node;
